import { awExposureSearchApi } from './Base';
import { CreateDistinctSecuritiesBatchIDRequestPayload, DistinctSecuritiesResponse } from './Models';

export const createDistinctSecuritiesBatchID = (payload: CreateDistinctSecuritiesBatchIDRequestPayload) => {
  const path = '/api/v1/count-distinct-cusips';
  return awExposureSearchApi.post<string>(path, payload, { params: { pkg: payload.pkg } });
};

export const getDistinctSecurities = (batchId: string, pkg: string) => {
  const path = `/api/v1/count-distinct-cusips/${batchId}`;
  return awExposureSearchApi.get<DistinctSecuritiesResponse>(path, { params: { pkg } });
};
